import React from 'react';
import { LayoutItem } from 'react-grid-layout';
import { ReactComponent as GatewayErrorIcon } from '../../../../../../../../assets/dashboard/GatewayError.svg';
import {
  ILabelValuePanel,
  IGatewayErrorPanel,
} from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import LabelValuePanel, {
  DefaultRightContainer,
} from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';
import { useTranslation } from 'react-i18next';
import useAirConnectStatusCount from '../../../../../../../../service/device/CommanderAPI/hooks/useAirConnectStatusCount';

export interface GatewayErrorPanelProps {
  panel: IGatewayErrorPanel;
  layout?: LayoutItem | undefined;
}

function GatewayErrorPanel(props: GatewayErrorPanelProps) {
  const { panel, layout } = props;
  const { t } = useTranslation();
  const { isLoading, currentData, error } = useAirConnectStatusCount(panel);

  const value =
    (currentData?.gatewayLost ?? 0) + (currentData?.gatewayTimeout ?? 0);

  const labelValuePanel: ILabelValuePanel = {
    type: 'LABEL_VALUE',
    id: `gateway_error`,
    title: panel.title,
    icon: <GatewayErrorIcon height={'100%'} />,
    content: (
      <DefaultRightContainer success={value === 0}>
        {value}
      </DefaultRightContainer>
    ),
    loading: isLoading,
    error: error ? t('dashboard.error.fetching') : undefined,
  };
  return <LabelValuePanel panel={labelValuePanel} layout={layout} />;
}

export default GatewayErrorPanel;
